module.exports = __webpack_public_path__ + "imgs/gosPartnersLogo4.19328b56.webp";